import { RESOURCE_ROOT_FIELDS } from '~/client/src/shared/constants/resourceTypes'

import { RESOURCE_NAME_KEY } from './definitions/types'

/**
 * The fields every form of a resource type carries whatever its template says:
 * Name, plus the resource's root columns (Equipment's icon / colour / parent).
 * The form editor renders them as non-removable rows, so anything counting or
 * listing a form's fields has to include them — read this rather than rebuilding
 * the list.
 *
 * Deliberately free of dependencies so list and counting code can use it without
 * pulling in the edit panel's hooks, stores or localization. Presentation for
 * these keys lives in `ROOT_FIELD_META`, and a test pins that every root field
 * has an entry there.
 */
export const getSystemFormFieldKeys = (resourceTypeId?: string): string[] => [
  RESOURCE_NAME_KEY,
  ...(RESOURCE_ROOT_FIELDS[resourceTypeId ?? ''] ?? []),
]
